import { EVENT_TYPE_MOTION, EVENT_TYPE_TRANSACTION } from '@solinkcorp/vd-common/lib/esm/constants';
import { type Precondition } from './types';

/* TODO: define in CH cloud level settings */
export const EVENT_PRECONDITIONS_FOR_WORKFLOW: Precondition[] = [
  {
    fieldPath: 'type',
    value: EVENT_TYPE_TRANSACTION,
    comparison: '=',
  },
  {
    fieldPath: 'type',
    value: EVENT_TYPE_MOTION,
    comparison: '=',
  },
  {
    fieldPath: 'shareDuration',
    value: 0,
    comparison: '>',
  },
  {
    fieldPath: 'subtype',
    value: 'ai-dwellTime',
    comparison: '=',
  },
  {
    fieldPath: 'subtype',
    value: 'ai-lineCrossing',
    comparison: '=',
  },
  {
    fieldPath: 'subtype',
    value: 'ai-zoneTracking',
    comparison: '=',
  },
  {
    fieldPath: 'subtype',
    value: 'ai-doorObstruction',
    comparison: '=',
  },
  {
    fieldPath: 'subtype',
    value: 'ai-openAI',
    comparison: '=',
  },
  {
    fieldPath: 'subtype',
    value: 'ACCESS',
    comparison: '=',
  },
  {
    fieldPath: 'subtype',
    value: 'ALARM',
    comparison: '=',
  },
  {
    fieldPath: 'subtype',
    value: 'agent',
    comparison: '=',
  },
];

export const DEFAULT_PRECONDITION: Precondition = {
  fieldPath: 'type',
  value: 'transaction',
  comparison: '=',
};

export const INITIAL_NODE_ID = 'entry-node';
export const FIRST_PROMPT_ID = 'first-prompt';
export const FIRST_PROMPT_YES_RESPONSE_ID = '0-yes';
export const FIRST_PROMPT_NO_RESPONSE_ID = '0-no';
export const FIRST_PROMPT_RESPONSES = [
  {
    id: FIRST_PROMPT_YES_RESPONSE_ID,
    value: 'yes',
  },
  {
    id: FIRST_PROMPT_NO_RESPONSE_ID,
    value: 'no',
  },
];
export const WORKFLOW_LAST_NODE_ID = 'verified';
export const WORKFLOW_GO_BACK_RESPONSE = 'go back';

export const CONTROL_TYPE_EMBEDDED_BUTTONS = 'embedded-buttons' as const;

export const MAX_PROMPT_LEVEL = 2;

export const VERIFEYE_EVENT_SUBTYPES = ['ACCESS', 'ALARM', 'agent'];

// Field path of the precondition that scopes a VerifEye flow to one alarm monitoring mode (the
// Stay Mode flow). MC reports the mode on the verification rather than on the event, so Callhome
// never evaluates this precondition itself - the flow is matched client-side by
// `findEventFlowByMonitoringMode`. It still has to read as a VerifEye flow here, or the
// Cloud-owned flow is offered to customers with Edit and Delete actions.
export const ALARM_MONITORING_MODE_FIELD_PATH = 'meta.alarmMonitoringMode';

export function isVerifEyeFlow(eventFlowMetadata: Record<string, any>): boolean {
  const precondition = eventFlowMetadata?.precondition;
  if (precondition?.fieldPath === ALARM_MONITORING_MODE_FIELD_PATH) {
    return true;
  }
  return (
    precondition?.fieldPath === 'subtype' && VERIFEYE_EVENT_SUBTYPES.includes(precondition?.value)
  );
}
